/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import {useMemo} from 'react'

import {useSuiContext} from '@s-ui/react-context'
import {ALL_SELECTIONS_ID} from '@adv-mt/mt-filter-basic/lib/config.js'
import FilterWrapperBasic, {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'

import {ICONS_MAP} from './config.js'

const FormCategory = ({
  aggregations = [],
  onChange,
  overlayContentRef,
  shape,
  showLabel,
  value,
  wrapper = filterWrapperBasicTypes.RIGHT_POPOVER_AUTOCLOSE
}) => {
  const {domain, i18n} = useSuiContext()

  const config = domain.get('config')

  const {FILTER_NAMES} = config.get('searchFilters')
  const {CATEGORIES_LEVEL_1} = config.get('vehicleSpecifications')
  const {FILTERS_PLACEHOLDERS} = config.get('filtersPlaceholders')

  const options = useMemo(
    () =>
      aggregations.map(({id}) => {
        const category = CATEGORIES_LEVEL_1[id]
        return {
          ...category,
          icon: ICONS_MAP[category.icon],
          label: i18n.t(category.name),
          value: id
        }
      }),
    [aggregations]
  )

  const handleChange = ({value}) => {
    const [selectedCategoryId] = value
    onChange(Number(selectedCategoryId))
  }

  return (
    <FilterWrapperBasic
      filters={[{name: FILTER_NAMES.CATEGORY_1, options}]}
      group={`${FILTER_NAMES.CATEGORY_1}Group`}
      legend={i18n.t('SEARCH.CATEGORY')}
      onChange={handleChange}
      overlayContentRef={overlayContentRef}
      placeholder={
        value ? i18n.t(CATEGORIES_LEVEL_1[value].name) : i18n.t(FILTERS_PLACEHOLDERS[FILTER_NAMES.CATEGORY_1])
      }
      shape={shape}
      showLegend={showLabel}
      value={{[FILTER_NAMES.CATEGORY_1]: [value ?? ALL_SELECTIONS_ID]}}
      withRemoveSelections={false}
      wrapper={wrapper}
    />
  )
}

export default FormCategory

FormCategory.displayName = 'FormCategory'
